export const validatePrice = (event) => {
    const newValue = `${event.target.value}${event.key}`
    // if (!(/^(\d+)?(\.)?(\.\d+)?$/).test(newValue)) old
    if (!(/^\d+\d?(\.)?(\d+)?$/).test(newValue))
        event.preventDefault()
}